export default "__VITE_ASSET__4HrgJJ4E__"